import { Box, Divider, Grid, Typography, styled, useTheme } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";
import { useMemo, useState } from "react";

function InvestmentPortfolioHistoryBox({ item }) {
  const theme = useTheme()
  const [showMore, setShowMore] = useState(false)

  const profitColor = useMemo(() => {
    if (+item?.percentageProfitOrLoss > 0) {
      return theme.palette.success.main
    }

    if (+item?.percentageProfitOrLoss < 0) {
      return theme.palette.error.main
    }

    return theme.palette.text.main

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item?.percentageProfitOrLoss])

  return (
    <HistoryBoxWrapper onClick={() => setShowMore(v => !v)}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.main">
            {item?.portfolio}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <CoinWrapper>
            <img src={DefaultUrlWeb + item?.coinImageUrl} alt="" />

            <Box>
              <Typography color="text.main" variant="h6" component="span">
                {item?.coinName}
              </Typography>
            </Box>
          </CoinWrapper>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle1">
            Total
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h5">
            <NumberFormats value={item?.total} />{" "}
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinName}
            </Typography>
          </Typography>
        </Grid>
      </Grid>

      <Grid container mt={1} spacing={1}>
        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Investment Amount
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.amountInvestment || 0} />{" "}
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinName}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Profit/Loss
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.profitOrLoss || 0} />{" "}

            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinName}
            </Typography>

            <br />

            <Typography
              component="span"
              variant="subtitle1"
              fontWeight={400}
              color={profitColor}
            >
              {item?.percentageProfitOrLoss} %
            </Typography>

          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Deposit Amount
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.amountDeposit || 0} />{" "}
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinName}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Deposit Fee
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.feeDeposit || 0} />{" "}
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinName}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Withdraw Amount
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.netAmountWithdraw || 0} />{" "}
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinName}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Withdraw Fee
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.feeWithdraw || 0} />{" "}
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinName}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Box dir="rtl">
            <Typography color="secondary.main" variant="h4">
              {!showMore ? "+" : "−"}
            </Typography>
          </Box>
        </Grid>

        {
          showMore &&
          <>
            <Grid item xs={12}>
              <Divider color={theme.palette.text.secondary} />
            </Grid>

            <Grid item xs={12}>
              <Typography color="text.secondary" fontWeight={500} variant="subtitle1">
                Date/Time Start Customer: {" "}
                <Typography
                  component="span"
                  color="text.main"
                  fontWeight={400}
                  variant="subtitle1"
                >
                  <b>
                    {item?.dateStartCustomer}
                  </b>{" "}
                  {item?.timeStartCustomer}
                </Typography>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography color="text.secondary" fontWeight={500} variant="subtitle1">
                Date/Time Start Admin: {" "}
                <Typography
                  component="span"
                  color="text.main"
                  fontWeight={400}
                  variant="subtitle1"
                >
                  <b>
                    {item?.dateStartAdmin}
                  </b>{" "}
                  {item?.timeStartAdmin}
                </Typography>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography color="text.secondary" fontWeight={500} variant="subtitle1">
                Date/Time Start Investment: {" "}
                <Typography
                  component="span"
                  color="text.main"
                  fontWeight={400}
                  variant="subtitle1"
                >
                  <b>
                    {item?.dateStartInvestment}
                  </b>{" "}
                  {item?.timeStartInvestment}
                </Typography>
              </Typography>
            </Grid>

            <Grid item xs={12} mt={2}>
              <Typography color="text.secondary" fontWeight={500} variant="subtitle1">
                Date/Time End Customer: {" "}
                <Typography
                  component="span"
                  color="text.main"
                  fontWeight={400}
                  variant="subtitle1"
                >
                  <b>
                    {item?.dateEndCustomer}
                  </b>{" "}
                  {item?.timeEndCustomer}
                </Typography>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography color="text.secondary" fontWeight={500} variant="subtitle1">
                Date/Time End Admin: {" "}
                <Typography
                  component="span"
                  color="text.main"
                  fontWeight={400}
                  variant="subtitle1"
                >
                  <b>
                    {item?.dateEndAdmin}
                  </b>{" "}
                  {item?.timeEndAdmin}
                </Typography>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography color="text.secondary" fontWeight={500} variant="subtitle1">
                Date/Time End Admin: {" "}
                <Typography
                  component="span"
                  color="text.main"
                  fontWeight={400}
                  variant="subtitle1"
                >
                  <b>
                    {item?.dateEndInvestment}
                  </b>{" "}
                  {item?.timeEndInvestment}
                </Typography>
              </Typography>
            </Grid>
          </>
        }
      </Grid>
    </HistoryBoxWrapper>
  );
}

const HistoryBoxWrapper = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  borderRadius: "8px",
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

const CoinWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  img: {
    marginRight: theme.spacing(1),
    width: "27px",
    height: "27px",
  },
}));

export default InvestmentPortfolioHistoryBox;
